import './css/style.css'
import './css/responcive.css'
import { Toaster } from 'react-hot-toast'
import Routers from './routers/Routers'

function App() {
  return (
    <>
      <Routers />
      <Toaster position='bottom-right' reverseOrder={false} />
    </>
  )
}

export default App
